import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { PlmService } from 'src/app/shared/services/plm.service';
import { ApiService } from 'src/app/shared/services/api.service';
import { ToastrMsgService } from 'src/app/shared/services/shared-services/toastr.service';

@Component({
  selector: 'app-progress-report',
  templateUrl: './progress-report.component.html',
  styleUrl: './progress-report.component.css'
})
export class ProgressReportComponent implements OnInit {
  reportForm!: FormGroup;
  selectedFile: File | null = null;
  projects: any[] = [];
  locations: any[] = [];
  workItems: any[] = [];

  constructor(
    private fb: FormBuilder,
    private plm: PlmService,
    private api: ApiService,
    private toastr: ToastrMsgService,
    private router: Router,
    private route: ActivatedRoute
  ) {}

  ngOnInit() {
    this.reportForm = this.fb.group({
      project_id: [null],
      work_location_id: [null],
      pavement_work_item_id: [null],
      reportDate: [new Date(), Validators.required],
      workDescription: ['', Validators.required],
      progressPercentage: ['', [Validators.required, Validators.min(0)]],
      qualityPassed: [false],
      inspectionDone: [false],
      photo: [''],
      latitude: [''],
      longitude: [''],
    });
    this.api.getProjectCommonAll({ page: 1, limit: 200 }).subscribe({
      next: (res: any) => {
        this.projects = res?.data || [];
        const projectId = this.route.snapshot.queryParamMap.get('project_id');
        if (projectId) {
          this.reportForm.patchValue({ project_id: Number(projectId) || projectId });
          this.onProjectChange();
        }
      },
    });
  }

  onProjectChange(): void {
    const projectId = this.reportForm.value.project_id;
    const q = { project_id: projectId || undefined };
    this.plm.listWorkLocations(q).subscribe({ next: (r: any) => (this.locations = r.data || []) });
    this.plm.listPavementWork(q).subscribe({ next: (r: any) => (this.workItems = r.data || []) });
  }

  onFileSelected(event: any) {
    this.selectedFile = event.target.files[0];
  }

  onUpload() {
    if (this.selectedFile) {
      console.log('Uploading:', this.selectedFile.name);
    }
  }

  onSubmit() {
    if (this.reportForm.invalid) return;
    const v = this.reportForm.value;
    const reportDate = v.reportDate instanceof Date ? v.reportDate.toISOString().slice(0, 10) : v.reportDate;
    this.plm
      .createDailyProgress({
        project_id: v.project_id,
        work_location_id: v.work_location_id,
        pavement_work_item_id: v.pavement_work_item_id,
        report_date: reportDate,
        qty: v.progressPercentage,
        remarks: v.workDescription,
      })
      .subscribe({
        next: () => {
          if (v.latitude && v.longitude) {
            this.plm
              .createMedia({
                project_id: v.project_id,
                work_location_id: v.work_location_id,
                caption: v.workDescription,
                latitude: v.latitude,
                longitude: v.longitude,
                file_url: this.selectedFile?.name || v.photo,
                content_type: this.selectedFile?.type || 'image',
              })
              .subscribe();
          }
          this.toastr.success('Daily progress saved');
          this.router.navigate(['/home/progress-report']);
        },
        error: (e) => this.toastr.error(e?.error?.message || 'Failed to save'),
      });
  }
}
